import { render, staticRenderFns } from "./categoryNameDialog.vue?vue&type=template&id=6a8a826a&scoped=true"
import script from "./categoryNameDialog.vue?vue&type=script&lang=js"
export * from "./categoryNameDialog.vue?vue&type=script&lang=js"
import style0 from "./categoryNameDialog.vue?vue&type=style&index=0&id=6a8a826a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8a826a",
  null
  
)

export default component.exports